export default `
  mutation deleteCardType($workflowId: ID!, $id: ID!) {
    deleteCardType(workflowId: $workflowId, id: $id) {
      id
      workflowId
    }
  }
`
